import permissions from './permissions';
import { PermissionsObject } from './types';

/**
 * Whether a permission may be assigned to an account. External accounts can
 * only be inventory counter; internal accounts can be anything but that.
 */
export function isAssignable(
  permission: keyof PermissionsObject,
  internal: boolean,
) {
  return internal === (permission !== 'INVENTORY_COUNTER');
}

/**
 * Bitmask of the permissions that may be assigned to an account
 */
export function assignableMask(internal: boolean) {
  let mask = 0;
  let key: keyof PermissionsObject;
  for (key in permissions) {
    if (isAssignable(key, internal)) {
      mask |= permissions[key];
    }
  }
  return mask;
}
